import { UseQueryResult, useQuery } from 'react-query'
import request from '../request'
import { User } from '../../lib/types/User'
import { Dealership } from '../../lib/types/Dealership'
import { VendorConnectionDetails } from '../../lib/types/VendorConnectionDetails'

type ResultType = {
  id: number
  name: string
  billing_email?: string
  created_date: string
  updated_date: string
  show_rsv: boolean
  show_budget_type: number
  has_logo: boolean
  vendor_connections: Array<
    VendorConnectionDetails & { is_managed: boolean; refresh_token?: string }
  >
  assigned_users: Array<User>
  assigned_dealerships: Array<Dealership>
  stripe_enabled?: boolean
  stripe_customer_id?: string
  is_tier_2?: boolean
  show_vendor_audiences?: boolean
}

export const useGetOrganizationByOrganizationId = (
  id: number,
): UseQueryResult<ResultType, Error> => {
  return useQuery<ResultType, Error>(['admin', 'organizations', id], ({ signal }) =>
    request<{ data: ResultType }>({
      url: `/admin/organizations/${id}`,
      method: 'GET',
      signal,
    }).then((res: { data: ResultType }) => res.data),
  )
}
